export { default as Img200 } from './processed/200/Aquaman.jpg';
export { default as Img400 } from './processed/400/Aquaman.jpg';
export { default as Imgthumb } from './processed/thumb/Aquaman.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Aquaman.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Aquaman.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      12,
      207,
      234
    ],
    "_population": 1875,
    "_hsl": [
      0.5202702702702703,
      0.902439024390244,
      0.48235294117647054
    ]
  },
  "LightVibrant": {
    "_rgb": [
      126,
      222,
      241
    ],
    "_population": 1914,
    "_hsl": [
      0.527536231884058,
      0.804195804195804,
      0.7196078431372549
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      6,
      33,
      110
    ],
    "_population": 2144,
    "_hsl": [
      0.6233974358974359,
      0.8965517241379309,
      0.2274509803921569
    ]
  },
  "Muted": {
    "_rgb": [
      182,
      146,
      129
    ],
    "_population": 204,
    "_hsl": [
      0.05345911949685533,
      0.2663316582914574,
      0.6098039215686275
    ]
  },
  "LightMuted": {
    "_rgb": [
      167,
      181,
      200
    ],
    "_population": 90,
    "_hsl": [
      0.5959595959595959,
      0.2307692307692307,
      0.7196078431372549
    ]
  },
  "DarkMuted": {
    "_rgb": [
      82,
      45,
      38
    ],
    "_population": 1927,
    "_hsl": [
      0.026515151515151523,
      0.36666666666666675,
      0.23529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Aquaman.js